var _atomStore$get;var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType } from
'react-router-dom';
import { Provider } from 'jotai';
import { Provider as ReduxProvider } from 'react-redux';

import { ErrorBoundary } from "./V2/Components/ErrorHandling";
import "./App/sockets";
import { getRoutes } from "./Routes";
import CustomProvider from "./App/Provider";
import { settingsAtom, atomStore, userAtom } from "./V2/atoms";
import { store } from "./store";







if (window.SENTRY_APP_DSN) {
  Sentry.init({
    release: window.UWAZI_VERSION,
    environment: window.UWAZI_ENVIRONMENT,
    dsn: window.SENTRY_APP_DSN,
    integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      )
    }),
    new Sentry.Replay()],


    tracesSampleRate: 0.1
  });
}

const router = createBrowserRouter(
  getRoutes(atomStore.get(settingsAtom), (_atomStore$get = atomStore.get(userAtom)) === null || _atomStore$get === void 0 ? void 0 : _atomStore$get._id)
);

const App = () => /*#__PURE__*/
_jsx(ReduxProvider, { store: store }, void 0, /*#__PURE__*/
_jsx(CustomProvider, {}, void 0, /*#__PURE__*/
_jsx(Provider, { store: atomStore }, void 0, /*#__PURE__*/
_jsx(ErrorBoundary, {}, void 0, /*#__PURE__*/
_jsx(RouterProvider, { router: router, fallbackElement: null })
)
)
)
);


const container = document.getElementById('root');
const root = window.__loadingError__ === undefined ? hydrateRoot(container, /*#__PURE__*/_jsx(App, {})) : container;
const silentWarnings = [
'Warning: %s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release.',
'Warning: %s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.%s',
'Warning: %s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release.',
'Warning: findDOMNode is deprecated and will be removed in the next major release.'];


const isSilentWarning = (warning) =>
silentWarnings.find((w) => typeof warning === 'string' && warning.includes(w)) !== undefined;

const origConsoleError = window.console.error;

window.console.error = (...args) => {
  if (isSilentWarning(args[0])) {
    return;
  }
  origConsoleError.apply(window.console, args);
};

export { root };